import {
    observable,
    action,
    toJS,
    runInAction
  } from 'mobx';
  import {ViewBase} from 'mutants-appfx';
  import _cloneDeep from 'lodash/cloneDeep'
  import {i18n} from 'mutants-microfx'
  import {Message} from 'tplus-components-touch'
  const t = i18n.getFixedT(null, 'appfx');
import tools from '../util/tools.js'
/* const input={
  head:'自由项选择',
  data:{
    title:[{name:'',value:''}],
    body:[
      {
        "Name": "FreeItem0",
        "Value": "",
        "Title": "颜色",
        "Range": [{
          "ID": 1,
          "Code": "001",
          "Name": "黄色"
        }, {
          "ID": 2,
          "Code": "002",
          "Name": "红色"
        }]
      }
    ]
  },
   cancelEnable:true
} */
  export default class FreeItemsModal extends ViewBase {
    get type(){
      return 'FreeItemsModal';
    }

    @observable visible = false;
    @observable title;
    @observable head;
    @observable freeItems=[];
    @observable errText='';
    @observable cancelEnable=true;
    @observable outData;

    constructor(store,name){
      super(store,name)
    }

    @action
    reset=()=>{
      this.freeItems=[];
      this.outData = {};
      this.title='';
    }

    @action input=(obj,out,outData={})=>{
      obj=_cloneDeep(obj);
      if(!obj.data||!obj.data.body)return;
      if( !tools.isNull(obj.cancelEnable) ){this.cancelEnable=obj.cancelEnable;}
      this.head=obj.head||'';
      this.title = obj.data.title;

      obj.data.body.forEach(item=>{
        if(!item.Value){
          item.Value = '';
        }
      });
      this.freeItems = obj.data.body;

      this.out=out;
      this.show();
    }

    @action freeItemSelect=(rangeItem,index)=>{
      this.freeItems[index].Value = rangeItem.Name;
    }

    @action
    ok=()=>{
      let noFreeItem = this.freeItems.find((freeitem)=>{
       return '' === freeitem.Value;
      });
      if(noFreeItem){
        const errText= `自由项[${noFreeItem.Title}]不能为空!`;
        Message.warn(t(errText))
        return;
      }
      this.out(toJS(this.freeItems));
      this.hide();
    }

    @action
    cancel=()=>{
      if(this.cancelEnable){
        this.out();
        this.hide();
      }
    }

    @action
    show=()=>{
        this.visible=true;
    }

    @action
    hide=()=>{
        this.visible=false;
        this.reset();
    }

    static fromJS(store, {FreeItems:initData}) {
      return new FreeItemsModal(store, 'FreeItemsModal','')
    }

  }
